// @ts-nocheck

  import SmileOutlined from '@ant-design/icons/es/icons/SmileOutlined';
import UserOutlined from '@ant-design/icons/es/icons/UserOutlined';
import LineChartOutlined from '@ant-design/icons/es/icons/LineChartOutlined';
import ProjectOutlined from '@ant-design/icons/es/icons/ProjectOutlined';
import BankOutlined from '@ant-design/icons/es/icons/BankOutlined';
import HomeOutlined from '@ant-design/icons/es/icons/HomeOutlined';
import ClockCircleOutlined from '@ant-design/icons/es/icons/ClockCircleOutlined';
import HighlightOutlined from '@ant-design/icons/es/icons/HighlightOutlined';
import UserSwitchOutlined from '@ant-design/icons/es/icons/UserSwitchOutlined';
import TableOutlined from '@ant-design/icons/es/icons/TableOutlined';
import ScheduleOutlined from '@ant-design/icons/es/icons/ScheduleOutlined';
import SolutionOutlined from '@ant-design/icons/es/icons/SolutionOutlined';
import TeamOutlined from '@ant-design/icons/es/icons/TeamOutlined';
import FileDoneOutlined from '@ant-design/icons/es/icons/FileDoneOutlined';
import UploadOutlined from '@ant-design/icons/es/icons/UploadOutlined';
import ProfileOutlined from '@ant-design/icons/es/icons/ProfileOutlined';
import ShopOutlined from '@ant-design/icons/es/icons/ShopOutlined';
import FileImageOutlined from '@ant-design/icons/es/icons/FileImageOutlined';
import NotificationOutlined from '@ant-design/icons/es/icons/NotificationOutlined';
import EditFilled from '@ant-design/icons/es/icons/EditFilled';
import CopyFilled from '@ant-design/icons/es/icons/CopyFilled';
import OrderedListOutlined from '@ant-design/icons/es/icons/OrderedListOutlined';
import ContainerOutlined from '@ant-design/icons/es/icons/ContainerOutlined';
import DollarOutlined from '@ant-design/icons/es/icons/DollarOutlined';
import MoneyCollectOutlined from '@ant-design/icons/es/icons/MoneyCollectOutlined';
import VideoCameraOutlined from '@ant-design/icons/es/icons/VideoCameraOutlined';
import SettingOutlined from '@ant-design/icons/es/icons/SettingOutlined'
  export default {
    SmileOutlined,
UserOutlined,
LineChartOutlined,
ProjectOutlined,
BankOutlined,
HomeOutlined,
ClockCircleOutlined,
HighlightOutlined,
UserSwitchOutlined,
TableOutlined,
ScheduleOutlined,
SolutionOutlined,
TeamOutlined,
FileDoneOutlined,
UploadOutlined,
ProfileOutlined,
ShopOutlined,
FileImageOutlined,
NotificationOutlined,
EditFilled,
CopyFilled,
OrderedListOutlined,
ContainerOutlined,
DollarOutlined,
MoneyCollectOutlined,
VideoCameraOutlined,
SettingOutlined
  }